export const EMPTY_FEATURES = Object.freeze({
    hazards: [],
    pickups: [],
    boostPads: [],
    platforms: [],
    concealment: [],
});
export function featuresOf(def) {
    if (!def)
        return EMPTY_FEATURES;
    return {
        hazards: def.hazards,
        pickups: def.pickups,
        boostPads: def.boostPads,
        platforms: def.platforms,
        concealment: def.concealment,
    };
}
/** True when `p` lies inside the yaw-rotated box (inclusive). */
export function pointInYawBox(p, box) {
    const dx = p.x - box.center[0];
    const dy = p.y - box.center[1];
    const dz = p.z - box.center[2];
    if (Math.abs(dy) > box.halfExtents[1])
        return false;
    // Rotate the offset into the box frame (undo the yaw about +Y).
    const c = Math.cos(box.yaw);
    const s = Math.sin(box.yaw);
    const lx = dx * c - dz * s;
    const lz = dx * s + dz * c;
    return Math.abs(lx) <= box.halfExtents[0] && Math.abs(lz) <= box.halfExtents[2];
}
/** The concealment zone a point is inside, or null. */
export function concealmentAt(features, p) {
    for (const zone of features.concealment)
        if (pointInYawBox(p, zone.box))
            return zone;
    return null;
}
export function freshArenaRuntime(features) {
    return {
        pickups: features.pickups.map(() => ({ respawnTick: 0 })),
        pads: features.boostPads.map(() => ({ readyTick: [0, 0] })),
    };
}
export function cloneArenaRuntime(r) {
    return {
        pickups: r.pickups.map((p) => ({ respawnTick: p.respawnTick })),
        pads: r.pads.map((p) => ({ readyTick: [p.readyTick[0], p.readyTick[1]] })),
    };
}
//# sourceMappingURL=features.js.map